<template>

  <div>
    <v-parallax height="620" src="./images/parrallax/18.png">
      <v-layout align-center justify-center>
        <v-flex xs10 sm8 md4 pt-2>

          <v-img src='../images/logo/banner.png'>
          </v-img>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row>
        <v-flex sm10 md4 class='header-title'>
          <blockquote class="blockquote font-weight-medium">
            <h1 class='display-1 text-uppercase font-weight-medium'>Time to put the conversation:</H1>
            <h2 class='headline text-uppercase font-italic'> in your customer's hands.</h2>
          </blockquote>

          <blockquote class="blockquote font-weight-medium">Engage is improving communication, gaining more business, and doing more as a business. See how Engage enables and improves
            your business' communication in a very simple way.</blockquote>
          <blockquote class="blockquote font-weight-medium">
            Quick answers, easy updates, start communicating via Text to your customers.
          </blockquote>
          <center>
            <v-btn color="info" tile to="/features">Features</v-btn>
            <v-btn color="info" tile class='ma-2' to="/contact">Request Demo</v-btn>
          </center>
        </v-flex>
        <v-flex  hidden-sm-and-down  md4>
          <v-img src='../images/screenshot.png' contain>
          </v-img>
        </v-flex>
      </v-layout>
    </v-parallax>

    <v-layout row wrap justify-center ma-5 text-center>
      <v-flex xs12 sm4 md2 ma-1 :key="index" v-for="(channel, index) in channels">
        <v-layout row wrap align-center justify-center ma-2>
          <v-flex xs12 text-xs-center>
            <v-icon size="100" color='light-blue'>{{ channel.icon }}</v-icon>
          </v-flex>
          <v-flex xs8 sm12>
            <P class="headline">{{ channel.headline}}</p>
          </v-flex>
          <v-flex xs8 sm12>
            {{ channel.desc }}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-parallax src="./images/parrallax/12r.png" height='600'>

      <v-layout row wrap align-center justify-start fill-height>
        <v-flex hidden-sm-and-down md2 offset-md2>
          <v-img src='../images/85percent2.png' contain>
          </v-img>
        </v-flex>
        <v-flex xs8 md3 class='content' text-xs-center>
          <p class='font-weight-medium display-1'>85% of consumers want to engage in text conversations with a business - not just receive information.
          </p>
          <footer id='feature'>(Franchise Help, Text Request)</footer>
        </v-flex>

      </v-layout>

    </v-parallax>

    <v-layout ma-5 pa-5 row wrap justify-center align-center>
      <v-flex sm8 md3 pa-5>
        <v-img src="./images/desktop.png">
        </v-img>
      </v-flex>
      <v-flex md5 pa-5>
        <h3 class='display-1 font-weight-medium mb-2'>Desktop 2-Way SMS Application</h3>
        <blockquote>
          Customers today are utilizing their mobile phones more than ever to find information, shop and communicate. With an estimated 98% open rate on SMS,
          businesses are investing in mobile communication and marketing. SMS is direct to your customer, cost-effective and simple to utilize. Providing the
          channels to communicate news, information, special offers, rewards and incentives.  Communicate openly with 2-way communication with image support.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-divider class='hidden-md-and-up'></v-divider>
    <v-layout ma-5 row wrap justify-center align-center pa-5>
      <v-flex md5 pa-5 order-xs2 order-md1>
        <h3 class='display-1 font-weight-medium mb-2'>Android and iOS Mobile Support</h3>
        <blockquote>
          With Engage you are no longer tied to a desk, keep the conversation going whereever you or your staff are.
          Engage is ready to be installed directly to your mobile device with Android or iOS. Keep your conversations on the
          go and allow your staff to respond anywhere they have internet access.
        </blockquote>
      </v-flex>
      <v-flex sm8 md3 pa-5 order-sm1>
        <v-img src="./images/feature/2.png">
        </v-img>
      </v-flex>
    </v-layout>
    <v-divider class='hidden-md-and-up'></v-divider>
    <v-layout ma-5 row wrap justify-center align-center pa-5>
      <v-flex sm8 md3 pa-5>
        <v-img src="./images/feature/1.png">
        </v-img>
      </v-flex>
      <v-flex md5 pa-5>
        <h3 class='display-1 font-weight-medium mb-2'>Website Widget</h3>
        <blockquote>
          Enhance your website with an SMS Widget allowing your customers to start a text conversation with your business. With multi
          location support your customers can choose the location closest to them to begin a text conversation. A customizable
          theme allows the Engage Widget to match your existing web design.
        </blockquote>
      </v-flex>
    </v-layout>


    <v-parallax src="./images/parrallax/19.png" height='600'>
      <v-layout align-center justify-center row>
        <v-flex md5 class="text-xs-center" offset-md4>
          <blockquote class='display-1 text-uppercase font-weight-black text-center black--text'>
            Get the missing piece to your communication puzzle.
          </blockquote>
        </v-flex>
      </v-layout>
    </v-parallax>


    <!--  Start Frequently Asked Questions -->
      <v-layout row wrap justify-center align-center fill-height ma-5 pa-5>
        <v-flex xs12 sm12 md6>
          <h1 class='text-center'>Frequently Asked Questions</h1>
          <v-expansion-panels popout>
            <v-expansion-panel
              v-for="(faq, index) in faq"
              :key="index"
            >
              <v-expansion-panel-header class='font-weight-medium blue--text text--darken-3'>{{ faq.question }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                {{ faq.answer }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
    <!--  End Frequently Asked Questions -->




    <v-parallax src="./images/parrallax/2.jpg" height='900'>

      <v-layout align-center justify-center row>
        <v-flex md8 class="text-xs-center">
          <blockquote class='display-1 text-uppercase font-weight-black white--text text-center'>
            Time to put the conversation in your customer's hands.
          </blockquote>
        </v-flex>
      </v-layout>

    </v-parallax>
  </div>

</template>

<script>

  export default {
    data() {
      return {
        features: [
          {
            src: '../images/icons/bell.svg',
            title: 'Push Notifications',
            desc: 'Receive automatic mobile or desktop notifcations when a text is recieved.'
          },
          {
            src: './images/icons/answer.svg',
            title: 'Quick Answer Templates',
            desc: 'Create responses that anyone in your shop can send with the click of a button'
          },
          {
            src: '../images/icons/notes.svg',
            title: 'Notes and History',
            desc: 'Write and save your own notes so that you can remember the important details'
          },
          {
            src: '../images/icons/color.svg',
            title: 'Colorful Conversations',
            desc: 'Quickly identify different types of conversations using colors you choose'
          },
          {
            src: '../images/icons/interoffice.svg',
            title: 'Android and iOS compatible',
            desc: 'Support for mobile devices lets you access and respond to your texts from anywhere'
          },
          // {
          //   src: '../images/icons/status.svg',
          //   title: 'Status Updates',
          //   desc: 'Whether you\'re a shop owner or a customer, getting updates on a job has never been faster'
          // },
          {
            src: '../images/icons/feedback.svg',
            title: 'Multi Location Support',
            desc: 'One business or many all managed from one login'
          }
        ],
        channels: [
          {
            headline: 'Increase Sales',
            desc: 'Connect with your leads faster with a 98% open rate, Fill and keep appointments.',
            icon: 'attach_money'
          },
          {
            headline: 'Streamline Services',
            desc: 'Improve productivity with fewer calls creating faster communication.',
            icon: 'business'
          },
          {
            headline: 'Engaged Marketing',
            desc: 'Engage with your customers on their preferred communication channel.',
            icon: 'people'
          },
          {
            headline: 'Improve Communication',
            desc: '58% of consumers have tried to reply to a missed call via text.',
            icon: 'sms'
          }
        ],
        faq: [
          {
            question: 'Can I use this on my mobile device?',
            answer: 'Engage is fully compatible with Apple iOS and Android.'
          },
          {
            question: 'Does my business get a specific phone number?',
            answer: 'Yes, you will be provided with an SMS number unique to your business.'
          },
          {
            question: 'Do you integrate with any CRM?',
            answer: 'Engage is ready to work with Production Board and SummitCRS with an 3rd Party API option for other systems.'
          },
          {
            question: 'Is there a contract?',
            answer: 'Engage is a month to month subscription based service, cancel at any time.'
          },
          {
            question: 'Do I get charged for incoming messages?',
            answer: 'Incoming messages do not cost you anything, a standard subscription will provide 1000 outgoing text messages per month with the option to add an addtional 1000 each month for just $20.'
          },
          {
            question: 'Can I adjust my plan for more messages?',
            answer: 'The standard plan for Engage includes 1000 outgoing messages per month you can add a 1000 more for just $20.'
          },
          {
            question: 'Whats included with my plan?',
            answer: 'Each plan includes unlimited users, devices, contacts, preset messages and more.'
          },
          {
            question: 'Is my data safe and secure?',
            answer: 'We take our security very seriously and have taken great attention to all details to ensure the safety and security of our application.'
          }

        ]
      }
    }
  }

</script>
